import i18n from "../../../../../../libs/i18n/i18n";

export const CARDS_PROP = {
  IMAGE: "image",
  IMAGE_SECOND: "imageSecond",
  TEXT_ALIGN: "textAlign",
  LAYOUT: "layout",
  BORDER_RADIUS: "borderRadius",
  NEW_TAB: "newTab",
  LINK: "link",
  TITLE: "title",
  TEXT: "text",
  LABEL: "label",
  ARROW: "arrow",
  OVERLAY: "overlay",
  DESIGN: "design",
  COLUMNS: "columns",
  ICON: "icon",
  HAS_TABS: "hasTabs",
  TAB_ID: "tabId",
  TYPE: "type",
  COLORS: "colors",
  LINK_TEXT: "linkText",
  NUMBER: "number",
  FORMAT: "format",
  START_WITH: "startWith",
  PREFIX: "prefix",
  CUSTOM_PREFIX: "customPrefix",
};

export const CARD_DESIGN = {
  IMAGE_ONE: "image-one",
  IMAGE_TWO: "image-two",
  IMAGE_THREE: "image-three",
  IMAGE_FOUR: "image-four",
  IMAGE_FIVE: "image-five",
  IMAGE_SIX: "image-six",
  IMAGE_SEVEN: "image-seven",
  IMAGE_EIGHT: "image-eight",
  IMAGE_NINE: "image-nine",
  EMOJI_ONE: "emoji-one",
  EMOJI_TWO: "emoji-two",
  ATLASSIAN_ONE: "atlassian-one",
  ATLASSIAN_TWO: "atlassian-two",
  STEPS_ONE: "steps-one",
  STEPS_TWO: "steps-two",
  STEPS_THREE: "steps-three",
  NUMBER_ONE: "number-one",
  NUMBER_TWO: "number-two",
  NUMBER_THREE: "number-three",
  TEXT_ONE: "text-one",
  TEXT_TWO: "text-two",
};

export const DESIGNS_OPTIONS = {
  ICON: [
    CARD_DESIGN.NUMBER_ONE,
    CARD_DESIGN.NUMBER_TWO,
    CARD_DESIGN.TEXT_ONE,
    CARD_DESIGN.IMAGE_EIGHT,
  ],
  IMAGE: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_FIVE,
    CARD_DESIGN.IMAGE_SIX,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.IMAGE_EIGHT,
    CARD_DESIGN.TEXT_TWO,
    CARD_DESIGN.IMAGE_NINE,
  ],
  SUBTEXT: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_FIVE,
    CARD_DESIGN.IMAGE_EIGHT,
    CARD_DESIGN.IMAGE_NINE,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_ONE,
    CARD_DESIGN.ATLASSIAN_TWO,
    CARD_DESIGN.STEPS_ONE,
    CARD_DESIGN.STEPS_TWO,
    CARD_DESIGN.STEPS_THREE,
    CARD_DESIGN.NUMBER_ONE,
    CARD_DESIGN.NUMBER_TWO,
    CARD_DESIGN.TEXT_ONE,
    CARD_DESIGN.TEXT_TWO,
  ],
  LINK_TEXT: [
    CARD_DESIGN.IMAGE_SIX,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.STEPS_ONE,
    CARD_DESIGN.TEXT_ONE,
  ],
  LABEL: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.IMAGE_EIGHT,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_ONE,
    CARD_DESIGN.ATLASSIAN_TWO,
    CARD_DESIGN.TEXT_TWO,
    CARD_DESIGN.STEPS_THREE,
  ],
  ARROW: [
    CARD_DESIGN.IMAGE_ONE,
    CARD_DESIGN.IMAGE_TWO,
    CARD_DESIGN.IMAGE_THREE,
    CARD_DESIGN.IMAGE_FOUR,
    CARD_DESIGN.IMAGE_SIX,
    CARD_DESIGN.IMAGE_SEVEN,
    CARD_DESIGN.EMOJI_ONE,
    CARD_DESIGN.EMOJI_TWO,
    CARD_DESIGN.ATLASSIAN_TWO,
    CARD_DESIGN.STEPS_ONE,
    CARD_DESIGN.STEPS_THREE,
    CARD_DESIGN.TEXT_ONE,
    CARD_DESIGN.TEXT_TWO,
    CARD_DESIGN.IMAGE_NINE,
  ],
  LABEL_COLOR: [CARD_DESIGN.IMAGE_SIX, CARD_DESIGN.TEXT_TWO],
  FORMAT: [
    CARD_DESIGN.STEPS_ONE,
    CARD_DESIGN.STEPS_TWO,
    CARD_DESIGN.STEPS_THREE,
  ],
  PREFIX: [CARD_DESIGN.STEPS_THREE],
};

export const getIconOptions = (t) => ({
  [CARD_DESIGN.NUMBER_ONE]: [t("icons"), t("emojis")],
  [CARD_DESIGN.NUMBER_TWO]: [t("icons"), t("emojis")],
  [CARD_DESIGN.EMOJI_ONE]: [t("icons"), t("emojis"), t("logos")],
  [CARD_DESIGN.EMOJI_TWO]: [t("icons"), t("emojis"), t("logos")],
  [CARD_DESIGN.TEXT_ONE]: [t("icons"), t("emojis")],
  [CARD_DESIGN.TEXT_TWO]: [t("icons"), t("emojis")],
  [CARD_DESIGN.IMAGE_EIGHT]: [t("icons")],
});

export const CARD_TYPE = {
  STEPS: "steps",
  NUMBER: "number",
  EMOJI: "emoji",
  TEXT: "text",
};

export const STEPS_FORMAT_TYPES = {
  PADDED_NUMERIC: "paddedNumeric",
  PLAIN_NUMERIC: "plainNumeric",
  ALPHABETIC: "alphabetic",
};

export const STEPS_FORMAT_NUMERIC_TYPES = [
  STEPS_FORMAT_TYPES.PADDED_NUMERIC,
  STEPS_FORMAT_TYPES.PLAIN_NUMERIC,
];

export const STEPS_FORMAT_START_WITH = {
  [STEPS_FORMAT_TYPES.PADDED_NUMERIC]: "01",
  [STEPS_FORMAT_TYPES.PLAIN_NUMERIC]: "1",
  [STEPS_FORMAT_TYPES.ALPHABETIC]: "A",
};

export const STEPS_MINIMUM_INTEGER_DIGITS = {
  [STEPS_FORMAT_TYPES.PADDED_NUMERIC]: 2,
  [STEPS_FORMAT_TYPES.PLAIN_NUMERIC]: 1,
};

export const LIBRARY_SERVICE_ACTION = {
  create: "addCard",
  edit: "editCard",
};

export const CARDS_GLOBAL_COLOR = [
  CARD_TYPE.STEPS,
  CARD_TYPE.NUMBER,
  CARD_TYPE.TEXT,
];

export const CARDS_SINGLE_COLOR = [
  CARD_DESIGN.STEPS_THREE,
  CARD_DESIGN.NUMBER_ONE,
];

export const CARD_DESIGN_COLUMNS = {
  [CARD_DESIGN.IMAGE_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_TWO]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_THREE]: [1, 2, 3, 4, 5],
  [CARD_DESIGN.IMAGE_FOUR]: [1, 2, 3, 4, 5],
  [CARD_DESIGN.IMAGE_FIVE]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_SIX]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_SEVEN]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_EIGHT]: [1, 2, 3, 4],
  [CARD_DESIGN.IMAGE_NINE]: [1, 2],
  [CARD_DESIGN.EMOJI_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.STEPS_THREE]: [1, 2, 3, 4],
  [CARD_DESIGN.ATLASSIAN_ONE]: [2, 3, 4],
  [CARD_DESIGN.ATLASSIAN_TWO]: [1, 2, 3, 4],
  [CARD_DESIGN.NUMBER_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.NUMBER_TWO]: [1, 2, 3, 4],
  [CARD_DESIGN.TEXT_ONE]: [1, 2, 3, 4],
  [CARD_DESIGN.TEXT_TWO]: [1, 2, 3, 4],
  DEFAULT: [1, 2, 3, 4, 5],
};
